import { useEffect, useState } from 'react';
import type { IServiceGroupWithEmailNotificationSettings } from '../../../../../common/interfaces/serviceGroupsWithEmailNotificationSettingsForEmployment';
import { useAbortableFetch } from '../../../../utils/hooks/useAbortableFetch';
import { ServiceEmailNotificationServiceGroupSettingsForm } from './ServiceEmailNotificationServiceGroupSettingsForm';

interface IServiceEmailNotificationSettingsEpisodeProps {
    employmentId: string;
    episodeCategory: string;
    readOnly: boolean;
}

export function ServiceEmailNotificationSettingsEpisode(props: IServiceEmailNotificationSettingsEpisodeProps) {
    const [serviceEmailNotificationSettings, setServiceEmailNotificationSettings] = useState<
        IServiceGroupWithEmailNotificationSettings[]
    >([]);

    const abortableFetch = useAbortableFetch();

    useEffect(() => {
        loadServices();
    }, [props.employmentId, props.episodeCategory]);

    return (
        <div style={{ margin: '32px 0' }}>
            {serviceEmailNotificationSettings.map((serviceGroup) => (
                <ServiceEmailNotificationServiceGroupSettingsForm
                    employmentId={props.employmentId}
                    isReadOnly={props.readOnly}
                    key={serviceGroup.id}
                    onCancelled={loadServices}
                    onSaved={loadServices}
                    serviceEmailNotificationSettingsForGroup={serviceGroup}
                />
            ))}
        </div>
    );

    async function loadServices() {
        const serviceGroupUrl = `/api/employments/${props.employmentId}/serviceEmailNotificationSettings/${props.episodeCategory}`;
        const serviceGroupResult = await abortableFetch.fetchJson(serviceGroupUrl, 'GET');

        setServiceEmailNotificationSettings(serviceGroupResult.json.items);
    }
}
